<template>
  <el-dialog title="Pagar Boleto Avulso" @open="iniciar" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body width="700px" v-loading="loading">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="Data Pagamento">
            <el-date-picker v-model="dataPagamento" v-mask="'##/##/####'" type="date" format="dd/MM/yyyy" value-format="dd/MM/yyyy" style="width: 100%"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Valor">
            <money auto-complete="off" v-model="boletoAvulso.valor" v-bind="money" class="el-input__inner"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Recebido através de " prop="formaRecebimento">
            <el-select v-model="boletoAvulso.formaRecebimento" clearable :disabled="desabilitarFormaRecebimento" value-key="data" placeholder="" filterable default-first-option style="width: 100%">
              <el-option v-for="item in formasRecebimento" :key="item.data" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10" v-if="boleto">
        <el-col :span="6">
          <el-form-item label="Data Crédito">
            <el-date-picker v-model="boletoAvulso.dataCredito" v-mask="'##/##/####'" type="date" format="dd/MM/yyyy" value-format="dd/MM/yyyy" style="width: 100%"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="pagarBoletoHandler" v-if="exibirBotaoPagarBoleto" type="primary" size="small" round >Pagar</el-button>
    </span>
  
    <app-detalhes-lancamento-caixa-dialog @close="fecharDetalhesLancamentoCaixaDialog" @pagarBoletoAvulso="pagarNaImobiliaria" :recibo="boletoAvulso" tipoRecibo="BOLETO_AVULSO" :totalDoAluguel="boletoAvulso.valor" v-if="boletoAvulso" :visibility="visibilidadeDetalhesLancamentoCaixaDialog"/>
  </el-dialog>

</template>

<script>
import { mapActions, mapState } from 'vuex'
import Util from '../../../util/funcoes.js';
import { FORMA_RECEBIMENTO } from '../../../util/constantes.js';
import { Money } from "v-money";

import AppDetalhesLancamentoCaixaDialog from '../../../shared/dialogs/DetalhesLancamentoCaixaDialog.vue';

export default {
  props: {
    boletoAvulsoProp: Object,
    visibility: Boolean,
    formaRecebimentoInicial: String
  },
  components: {
    AppDetalhesLancamentoCaixaDialog,

    Money
  },
  data() {
    return {
      boletoAvulso: {
        ...this.boletoAvulsoProp
      },

      dataPagamento: Util.hoje(),

      validacao: {
        formaRecebimento: [
          { type: "string", required: true }
        ]
      },

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      visibilidadeDetalhesLancamentoCaixaDialog: false
    }
  },
  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) { return state.usuarioLogado },
      permissoes(state) { return state.usuarioLogado.permissoes.filter((permissao) => { return permissao.modulo == "CLIENTES_ALUGUEL" })[0] }
    }),
    formasRecebimento() {
      return FORMA_RECEBIMENTO;
    },
    desabilitarFormaRecebimento() {
      return !this.permissoes.alterarFormaPagamentoAluguel
    },

    exibirBotaoPagarBoleto(){
      return this.boletoAvulsoProp.status === "EM_ABERTO"
    },

    boleto() {
      return (this.boletoAvulso.formaRecebimento == "BOLETO")
    },
    transferenciaBancaria() {
      return (this.boletoAvulso.formaRecebimento == "TRANSFERENCIA_BANCARIA")
    },
    pagoNaImobiliaria() {
      return (this.boletoAvulso.formaRecebimento == "CAIXA_DA_IMOBILIARIA")
    },
    cartaoDeCredito() {
      return (this.boletoAvulso.formaRecebimento == "CARTAO_DE_CREDITO")
    },
    acordo() {
      return (this.boletoAvulso.formaRecebimento == "ACORDO")
    },
    loading() {
      return this.$store.state.loading;
    }
  },
  methods: {
    ...mapActions([
        'showLoading',
        'hideLoading'
    ]),
    ...mapActions('alugueisContratosStore', [
        'pagarBoletoAvulso'
    ]),
    iniciar() {
      this.reset();
    },
    pagarBoletoHandler() {
      if(this.pagoNaImobiliaria) {
					this.exibirDetalhesLancamentoCaixaDialog();
				} else {
					this.pagar();
				}
    },

    pagarNaImobiliaria(detalhesLancamento) {
      this.visibilidadeDetalhesLancamentoCaixaDialog = false
      this.boletoAvulso.lancamentoCaixa = {}
      this.boletoAvulso.lancamentoCaixa.detalhesLancamento = detalhesLancamento;
      this.pagar()
    },

    pagar() {
      if(this.dadosValidos()) {
        this.boletoAvulso.status = "PAGO";
        this.boletoAvulso.dataPagamento = this.dataPagamento
        this.boletoAvulso.valorPagamento = this.boletoAvulso.valor
        
        if(!this.boleto) {
          this.boletoAvulso.dataCredito = this.dataPagamento
        }
        
        if(this.pagoNaImobiliaria) {
          this.boletoAvulso.lancamentoCaixa.operacao = 'ENTRADA';
          this.boletoAvulso.lancamentoCaixa.descricao = 'Pagamento de Boleto Avulso';
          this.boletoAvulso.lancamentoCaixa.valor = this.boletoAvulso.valorPagamento;
        }
        
        this.showLoading();
        this.pagarBoletoAvulso(this.boletoAvulso)
        .then((resultado) => {
            this.hideLoading();
            switch(resultado.status) {
                case "SUCESSO":
                    this.$message.success(resultado.mensagem);
                    this.pagoComSucesso();
                    break;
                case "FALHA":
                    this.$message.warning(resultado.mensagem);
                    break;
                default:
                    this.$message.error(resultado.mensagem);
                    break;
            }
        }).catch(() => {
            this.hideLoading();
        });
      } else {
        if(this.boleto) {
          this.exibirAlert("Atenção", "Digite a data de crédito do boleto");
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      }
    },

    
    dadosValidos() {
      var validacao = true;
      
      validacao = this.boletoAvulso.formaRecebimento && validacao;
      
      if(this.boleto) {
        validacao = this.boletoAvulso.dataCredito && validacao;
      }
      
      return validacao;
    },

    formatarValor(valor) {
      return Util.formatarValor(valor)
    },
    exibirDetalhesLancamentoCaixaDialog() {
        this.visibilidadeDetalhesLancamentoCaixaDialog = true
    },
    fecharDetalhesLancamentoCaixaDialog() {
        this.visibilidadeDetalhesLancamentoCaixaDialog = false
    },

    exibirAlert(titulo, mensagem) {
        this.$alert(mensagem, titulo, { confirmButtonText: 'OK' });
    },
    pagoComSucesso(){
      this.$emit('close','SUCESSO');
    },
    fechar() {
      this.$emit('close');
    },

    reset() {
      this.dataPagamento = Util.hoje();
      this.boletoAvulso = {
        ...this.boletoAvulsoProp
      };
    }
  }
}
</script>
